import React, { useState, useRef } from 'react'
import { Accordion, Button, Container, Form, FormControl, InputGroup, Nav, Row, Col, Tab, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { data } from '../data';
import styles from './Archives.module.scss';
import { useHistory, useParams, useLocation } from 'react-router-dom'

const ArchivesSoftware = () => {
    let loc = window.location.hash;
    loc = loc.slice(1);
    const history = useHistory();
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState('');
    const [copied, setCopied] = useState(false);
    const [show, setShow] = useState(false);
    const [shown, setShown] = useState(false);
    const target = useRef(null);
    const [selectedTab, setSelectedTab] = useState(location.search.substring(1));
    const handleSelect = (e) => {
        //set state
        setSelectedTab(e);
        //update url
        history.replace({
            search: `${e}`
        });
    }
    const handleCopy = () => {
        setCopied(true);
    };

    const clickOnButton = () => {
        setShown(true);
    }

    const handleClick = (e) => {
        e.stopPropagation();
        setShow(!show);
        setShown(true);
        setTimeout(() => {
            setShown(false);
        }, 2000);
    };

    const handleClickIndex = (index) => {
        setShow(!show);
        setShown(index);
        setTimeout(() => {
            setShown(false);
        }, 2000);
    };

    const [hover, sethover] = useState(null);

    const handleStop = (e) => {
        e.stopPropagation();
    }

    const handleMouseEnter = (index) => {
        sethover(index);
        setTimeout(() => {
            sethover(false);
        }, 3000);
    }
    return (<>

        <Container className='outerContainer'>
            <h1 className="centerText mb-4">Software</h1>
        </Container>
        <Container className="outerContainer">
            <div className={styles.searchContainer}>
                <h3 className={styles.searchHeading}>Filter</h3>
                <Form className="flex">
                    <Form.Group className={styles.search} controlId="formBasicEmail">
                        <InputGroup className={styles.inputGroup}>
                            <FormControl className={styles.searchBox} placeholder="Please enter a search term (i.e. Specifications, Benchmark, etc...)" onChange={event => { setSearchTerm(event.target.value) }} />
                            <Button className={styles.resetButton} type="reset" onClick={event => { setSearchTerm('') }}>Reset Search</Button>
                        </InputGroup>
                    </Form.Group>
                </Form>
            </div>
        </Container>
        <Container className='outerContainer'>
        <Tab.Container id="left-tabs-example" activeKey={selectedTab ? selectedTab : '1'} onSelect={(e) => handleSelect(e)}>
                <Row>
                    <Col md={3}>
                        <Nav variant="pills" className="flex-column">
                            {data.archives.map((information, index) => (<>
                                {information.software.map((soft, index) => (<>
                                    <Nav.Item>
                                        <Nav.Link id={index + 1} eventKey={index + 1}>{soft.faqtopic}</Nav.Link>
                                        <hr className="divider-blue" />

                                    </Nav.Item>
                                </>))}
                            </>))}
                        </Nav>
                    </Col>
                    <Col md={9}>
                    {searchTerm == "" ? null : <h5>Showing results for: "{searchTerm}"</h5>}
                        {data.archives.map((information, index) => (<>
                            {information.software.map((soft, index) => (<>
                                <Tab.Content>
                                    <Tab.Pane eventKey={index + 1}>
                                    {soft.children.filter((child) => {
                                        if (searchTerm == "") {
                                            return child
                                        } else if (child.faqSubtopic.toLowerCase().includes(searchTerm.toLowerCase())) {
                                            return child
                                        }
                                        else if (child.faqanswer.toLowerCase().includes(searchTerm.toLowerCase())) {
                                            return child
                                        }
                                    }).map((child, index) => (<>
                                            <Accordion id={child.tag} className={styles.faqsAccordion} eventKey={child.tag} defaultActiveKey={loc.length === 0 ? "empty" : loc}>
                                                <Accordion.Item eventKey={child.tag}>
                                                    <Accordion.Header id={child.tag} >
                                                        <div className={styles.accordionHeading}>
                                                            <div className={styles.subTopicHeading}>{child.faqSubtopic}</div>
                                                            <div ref={target}>
                                                                {hover === index ? <div className={styles.copyContainer}><i className="fa fa-check-circle"></i><span className={styles.copiedText}>Copied to Clipboard</span></div> :
                                                                <CopyToClipboard text={`${window.location.origin}` + `${window.location.pathname}` + "?" + `${selectedTab ? selectedTab : '1'}` + "#" + `${child.tag}`} onCopy={handleCopy}>
                                                                <Button variant="link" className={styles.copyBtn} onClick={(e) => e.stopPropagation()}>
                                                                            <a onClick={() => handleMouseEnter(index)}>Share</a>
                                                                        </Button>
                                                                    </CopyToClipboard>
                                                                }
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <Row className={styles.accordionContent}>
                                                            <Col md={12}>
                                                                <div dangerouslySetInnerHTML={{ __html: child.faqanswer }} />
                                                            </Col>
                                                        </Row>
                                                    </Accordion.Body>

                                                </Accordion.Item>
                                            </Accordion>
                                        </>))}
                                    </Tab.Pane>
                                </Tab.Content>
                            </>))}
                        </>))}
                    </Col>
                </Row>
            </Tab.Container>
        </Container>
    </>)
}


export default ArchivesSoftware;